import { GraphQLNonNull, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import { SensitiveDataMaskingSettings } from '../../../components/sensitive-data'
import { sensitiveDataMaskingSettingsType } from '../types/sensitive-data-types'

interface SensitiveDataMaskingSettingsQueryArgs {
  readonly organizationID: string
}

const sensitiveDataMaskingSettingsQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export const sensitiveDataMaskingSettings: ContrastGraphQLFieldConfig<
  any,
  Context,
  SensitiveDataMaskingSettingsQueryArgs,
  SensitiveDataMaskingSettings
> = {
  description: 'Get sensitive data masking settings by organization ID',
  type: new GraphQLNonNull(sensitiveDataMaskingSettingsType),
  args: sensitiveDataMaskingSettingsQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID } = args
    const maskAttackVector = await context.connector.get(
      `${organizationID}/feature/sensitive-data-mask-attack-vector`
    )

    const maskHttpBody = await context.connector.get(
      `${organizationID}/feature/sensitive-data-mask-entire-body`
    )
    return {
      organizationID,
      maskHttpBody: maskHttpBody && maskHttpBody.enabled,
      maskAttackVector: maskAttackVector && maskAttackVector.enabled
    }
  }
}
